import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import EditarPerfil from "../../Screens/Perfil/EditarPerfil";
import Perfil from "../../Screens/Perfil/PerfilScreen";
import CanjearGuads from "../../Screens/Perfil/CanjearGuads";
import PerfilItinerari from "../../Screens/Perfil/PerfilItinerari";

const Stack = createStackNavigator();

export default function PerfilNavigator() {
  return (
    <Stack.Navigator
      initialRouteName="PerfilDetall"
      screenOptions={{ headerShown: false }}
    >
      <Stack.Screen name="PerfilDetall" component={Perfil} />
      <Stack.Screen name="EditarPerfil" component={EditarPerfil} />
      <Stack.Screen name="CanjearGuads" component={CanjearGuads} />
      <Stack.Screen name="PerfilItinerari" component={PerfilItinerari} />
    </Stack.Navigator>
  );
}
